var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof Console !== "undefined") return resolve();
	__webpack_require__.l("https://console-test.hxxlpg.com/consoleEntry_20250807144914.js", function(event) {
		if(typeof Console !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "Console");
}).then(function() { return Console; });